module.exports = "<a routerLink=\"/posts\" class=\"btn btn-light btn-sm\">Back</a>\n\n<div *ngIf=\"post\" class=\"card\">\n  <div class=\"card-body\">\n    <h3>{{ post.title }}</h3>\n    <p>{{ post.body }}</p>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/markl/projects/angularapp/src/app/components/post/post.component.html
// module id = ../../../../../src/app/components/post/post.component.html
// module chunks = main